export const url = {
  api:"https://us-central1-channel-talks-web.cloudfunctions.net/app",
  web:"https://channel-talks-web.web.app"
}

/*
export const url = {
  api:"http://127.0.0.1:5001/channel-talks-web/us-central1/app",
  web:"localhost:3000"
}
*/



